import maskInputDataCreditCard from 'scripts/miscellaneous/maskInputDataCreditCard.js';
import createOrUpdateCreditCard from './script-fraction/createOrUpdateCreditCard.js';

const miscellaneous = () => {
    $('.payment-edit').on('click', function(){
        var subscriptionId = $(this).attr('data-subscription');
        $('.payment-plan-name').html($(this).closest('#div-subscription-' + subscriptionId).find('.plan-name').text());
        $('.payment-plan-id').html('ID' + subscriptionId);
        $('.payment-subscription-id').html(subscriptionId);

        var cardId = $(this).attr('data-card');
        $('#div-cards input[name="card"][value=' + cardId + ']').prop('checked', true);
    });


    $('#my-subscriptions-payment').on('hidden.bs.modal', function () {
        $('#form-payment-new').trigger('reset');
        var messages = document.getElementById('alert-payment-messages');
        messages.innerHTML = '';
    });

    $( document ).ready(function() {
        $('.card-icon').click(function () {
            $('.card-icon.checked').not(this).removeClass('checked');
            $(this).toggleClass('checked');
        });
    });
};

export default () => {
    if (!document.getElementById('my-subscriptions-payment')) return;

    (function() {
        let period = 300;
        let limit = 20 * 1e3;
        let nTry = 0;
        let intervalID = setInterval(function() {
            let clear = limit/period <= ++nTry;
            if ($('.payment-edit').length > 0) {
                miscellaneous();
                clear = true;
            }
            if (clear) {
                clearInterval(intervalID);
            }
        }, period);
    })();

    maskInputDataCreditCard();
    createOrUpdateCreditCard();
}



// WEBPACK FOOTER //
// ./scripts/routes/views/partials/dashboard-pages/mySubscriptionsPaymentModal.js